import initAddonTransaction from './init_addon_transaction';

export default () => {
  initAddonTransaction();
};
